/**
 * @generated SignedSource<<fed974627785aab34af88f822f66e13c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useIssueQueryIssueContent$data = {
  readonly assignees: {
    readonly nodes: ReadonlyArray<{
      readonly login: string;
    } | null | undefined> | null | undefined;
  };
  readonly body: string;
  readonly databaseId: number | null | undefined;
  readonly id: string;
  readonly issueType: {
    readonly name: string;
  } | null | undefined;
  readonly labels: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly milestone: {
    readonly title: string;
  } | null | undefined;
  readonly number: number;
  readonly projectItems: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly project: {
        readonly id: string;
        readonly title: string;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly repository: {
    readonly databaseId: number | null | undefined;
    readonly defaultBranchRef: {
      readonly name: string;
    } | null | undefined;
    readonly id: string;
    readonly isArchived: boolean;
    readonly isCopilotAgentEnabled: boolean | null | undefined;
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  };
  readonly subIssues: {
    readonly totalCount: number;
  };
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "useIssueQueryIssueContent";
};
export type useIssueQueryIssueContent$key = {
  readonly " $data"?: useIssueQueryIssueContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIssueQueryIssueContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIssueQueryIssueContent"
};

(node as any).hash = "a175c12fb4b38762491470789bca7dee";

export default node;
